module.exports = __webpack_public_path__ + "img/icn_tool@3x.4488b4d4.png";